<template>
  <div class="curso">
    <button class="edit-section">
      <img
        src="@/assets/icons/menu/edit-white.svg"
        style="z-index: 100"
        @click="redirect(course.id)"
      />
    </button>

    <img src="@/assets/default-cover.svg" />

    <div class="content">
      <p class="title">
        {{ course.name }}
      </p>

      <p class="description">
        {{ course.description }}
      </p>

      <div class="price">
        <span class="active">{{ course.newPrice }}</span
        ><span class="older">{{ course.oldPrice }}</span>
      </div>

      <button v-if="course.approved" class="aprovado">Aprovado</button>
      <button v-else class="em_analise">Em construção</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Course',
  props: ['course'],
  methods: {
    redirect(id) {
      // courseId = this.
      this.$router.push('/teacher/courses/' + id);
    },
  },
};
</script>

<style lang="scss" scoped>
.curso {
  width: 100%;
  max-width: 348px;
  margin: 9px 9px;
  background: #fff;
  flex-grow: 1;
  flex-basis: 348px;
  position: relative;

  .edit-section {
    position: absolute;
    top: 1.5%;
    right: 1.5%;
    cursor: pointer;
    background: transparent;
    border: none;
  }

  img {
    display: block;
    width: 100%;
  }

  .content {
    padding: 20px 30px 25px 30px;

    .title {
      font-weight: 500;
      font-size: 1.25rem;
    }

    .description {
      font-weight: 400;
      color: #66788a;
    }

    .price {
      margin-top: 8px;
      margin-bottom: 10px;
    }

    button {
      width: 100%;
      height: 54px;
      color: #fff;
      font-weight: 500;
      font-size: 1.25rem;
      border: none;
      border-radius: 4px;
    }
  }
}
.aprovado {
  background: #2cb55b;
}
.em_analise {
  background: gray;
}
@media (max-width: 768px) {
  .curso {
    margin: 9px 0;
  }
}
</style>